import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import {
  GET_CUSTOM_QUALITY_OF_LIFE_INDICATOR_CONFIGS,
  GET_QUALITY_OF_LIFE_INDICATOR_CONFIGS,
} from "../../queries/qualityOfLifeIndicatorQueries";

export function useQualityOfLifeIndicatorConfigs() {
  const {
    data: baseData,
    loading: baseLoading,
    error: baseError,
    refetch: refetchBase,
  } = useQuery(GET_QUALITY_OF_LIFE_INDICATOR_CONFIGS, {
    fetchPolicy: "cache-first",
  });

  const {
    data: customData,
    loading: customLoading,
    error: customError,
    refetch: refetchCustom,
  } = useQuery(GET_CUSTOM_QUALITY_OF_LIFE_INDICATOR_CONFIGS, {
    fetchPolicy: "network-only",
  });

  const configs = useMemo(() => {
    const baseConfigs =
      baseData?.qualityOfLifeIndicatorConfigs?.map(cfg => ({
        ...cfg,
        isCustomConfig: false,
        max_value: cfg?.max_value ?? null,
      })) || [];
    const customConfigs =
      customData?.customQualityOfLifeIndicatorConfigs?.map(cfg => ({
        ...cfg,
        isCustomConfig: true,
        max_value: cfg?.max_value ?? null,
      })) || [];

    return [...customConfigs, ...baseConfigs];
  }, [baseData, customData]);

  const loading = baseLoading || customLoading;
  const error = baseError || customError;

  const refreshQualityOfLifeIndicatorConfigs = async () => {
    await Promise.all([refetchBase(), refetchCustom()]);
  };

  return {
    configs,
    loading,
    error,
    refreshQualityOfLifeIndicatorConfigs,
  };
}
